// Creative activities live inside the woodland, never as separate desktop apps.
export const creativeApps = {
  playground: {label:'Alex’s world',title:'Alex’s world',render:()=>`<iframe class="woodland-frame" src="/concepts/woodland.html?embedded=1" title="Alex’s pixel world — kitchen, track, and sound studio" allow="autoplay; fullscreen"></iframe>`},
};
export const soundBack = '';
export function stopApp(el) {
  el.querySelector('iframe')?.contentWindow?.postMessage({type:'desktop-activity',active:false},location.origin);
}
export function activateApp(el) {
  el.querySelector('iframe')?.contentWindow?.postMessage({type:'desktop-activity',active:true},location.origin);
}
